import { LayerGroup, GeoJSON } from "react-leaflet";
import { ILocationDeliveryAreaLayerProps } from "./interfaces";

export const LocationDeliveryAreaLayer: React.FC<ILocationDeliveryAreaLayerProps> =
  (props: ILocationDeliveryAreaLayerProps) => {
    return (
      <LayerGroup>
        {props.deliveryAreaGeoJSONList.map((value, index) => {
          const json = JSON.parse(value.geoJson);
          json.properties.style = {
            weight: 3,
            color: value.color ?? "#f18113",
            opacity: 0.9,
            fillColor: value.color ?? "#f18113",
            fillOpacity: 0.2,
          };
          json.properties.underConstruction = false;

          return (
            <GeoJSON
              key={`geojson-${index}`}
              data={json}
              style={(feature) => feature?.properties?.style}
            />
          );
        })}
      </LayerGroup>
    );
  };
